import './Home.css';

function Home() {
  return (
    <div className="home-page">
      <div className="hero">
        <h1>Welcome to The Otto</h1>
        <p>Bold Flavors. Unforgettable Vibes.</p>
      </div>

      <section className="intro">
        <h2>Experience Elevated Dining</h2>
        <p>
          At The Otto, we blend rich flavors and vibrant ambiance to create a one-of-a-kind dining
          experience. Whether you're in the mood for our signature SH Burger or a handcrafted pasta,
          every dish is made with passion.
        </p>
      </section>

    
    </div>
  );
}

export default Home;
